import React, { useEffect, useState } from "react";
import { slide as Menu } from "react-burger-menu";
import { NavLink } from "react-router-dom";
import "./Header.scss";

import { getRegisterUrl } from "../helpers/getRegisterUrl";
import useScrollDirection from "../hooks/useScrollDirection";
import logo from "../logo.svg";
import logo_red from "../logo_red.svg";

function Header() {
	const scrollDirection = useScrollDirection();
	const [menuOpen, setMenuOpen] = useState(false);

	const closeMenu = () => {
		setMenuOpen(false);
	};

	const links = [
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/"
			end
			onClick={closeMenu}
			key={"link_arbeitnehmer"}
		>
			Arbeitnehmer
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/arbeitgeber"
			onClick={closeMenu}
			key={"link_arbeitgeber"}
		>
			Arbeitgeber
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/haendler"
			onClick={closeMenu}
			key={"link_haendler"}
		>
			Radl-Händler
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/marken"
			onClick={closeMenu}
			key={"link_marken"}
		>
			Marken
		</NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/ablauf"
			onClick={closeMenu}
			aria-current="page"
			key={"link_ablauf"}
		>
			Ablauf
		</NavLink>,
		// <NavLink
		// 	tabIndex={0}
		// 	className={(navData) => (navData.isActive ? "active" : "")}
		// 	to="/gewinnspiel"
		// 	onClick={closeMenu}
		// 	key={"link_gewinnspiel"}
		// >
		// 	Gewinnspiel
		// </NavLink>,
		<NavLink
			tabIndex={0}
			className={(navData) => (navData.isActive ? "active" : "")}
			to="/kontakt"
			onClick={closeMenu}
			key={"link_kontakt"}
		>
			Kontakt
		</NavLink>,
		<a
			tabIndex={0}
			href={getRegisterUrl()}
			target="_blank"
			className="button"
			rel="noreferrer"
			key={"link_login_register"}
		>
			Login & Registrierung
		</a>,
	];

	const getNavLinks = () =>
		document.querySelectorAll<HTMLElement>('.Header nav.desktop a[tabindex="0"]');

	const handleKeyDown = (event: KeyboardEvent) => {
		const navLinks = getNavLinks();
		if (navLinks.length === 0) return;

		const focusedIndex = Array.from(navLinks).indexOf(document.activeElement as HTMLElement);
		if (focusedIndex === -1) return;

		if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
			event.preventDefault();
			const next = focusedIndex < navLinks.length - 1 ? focusedIndex + 1 : 0;
			navLinks[next].focus();
		} else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
			event.preventDefault();
			const prev = focusedIndex > 0 ? focusedIndex - 1 : navLinks.length - 1;
			navLinks[prev].focus();
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown);
		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, []);


	return (
		<header
			className={`Header ${scrollDirection === "down" ? "hide" : "show"}`}
		>
			<div className="content">
				<NavLink
					className={(navData) => (navData.isActive ? "active" : "")}
					to="/"
					  onClick={(e) => {
						e.preventDefault();
						 window.location.href = "/cms"; 
						}}
				>
					<picture className={"logo"}>
						<img
							src={logo}
							alt="Logo von FIRMENRADL"
							title="Logo von FIRMENRADL"
							aria-hidden="true"
							className={"white"}
							width={152}
						/>
						<img
							src={logo_red}
							alt="Logo von FIRMENRADL"
							title="Logo von FIRMENRADL"
							aria-hidden="true"
							className={"red"}
							width={152}
						/>
					</picture>
				</NavLink>

				<nav className={"desktop"} role="navigation">
					<ul>
						{links.map((link) => (
							<li key={`link_desktop_${link.key}`}>{link}</li>
						))}
					</ul>
				</nav>
				<nav className={"mobile"} role="navigation">
					<Menu
						width={"100vw"}
						right
						aria-label="menunav"
						aria-controls="main-content"
						isOpen={menuOpen}
						onOpen={() => setMenuOpen(true)}
						onClose={() => setMenuOpen(false)}
						aria-expanded={menuOpen}
					>
						{links.map((link) => link)}
					</Menu>
				</nav>
			</div>
		</header>
	);
}

export default Header;
